<template>
  <div>
    <CoverBg
      show-text
      title="Vacancies"
      text="Our doors are open to new specialists who look for new opportunities and experience"
    />
    <b-container class="main-container content-padding-t-b-100">
      <Loading v-if="loading" />
      <div v-else>
        <VacanciesItem
          v-for="(item, i) in vacancyList"
          :key="i"
          :vacancy="item"
          box-bordered
          link-item
        />
        <b-pagination
          v-if="totalRecords"
          :value="page"
          :total-rows="totalRecords"
          :per-page="PAGE_SIZE"
          align="center"
          size="sm"
          pills
          @change="changePage"
        />
      </div>
      <h3
        v-if="!totalRecords && !loading"
        class="font-weight-bold text-center main-blue"
      >
        Vacancies page is empty
      </h3>
    </b-container>
    <CoverBg bg="cover-bg-page-bottom" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CoverBg from '@/components/CoverBg';
import VacanciesItem from '@/components/Vacancies/VacanciesItem';
import Loading from '@/components/Loading';
import { scrollToTop } from '@/helpers/helpers';

const PAGE_SIZE = 5;

export default {
  name: 'Vacancies',
  components: {
    Loading,
    VacanciesItem,
    CoverBg,
  },
  data() {
    return {
      PAGE_SIZE,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      vacancyList: (state) => state.vacancies.vacancyList,
      page: (state) => state.vacancies.page,
      totalRecords: (state) => state.vacancies.totalRecords,
    }),
  },
  async created() {
    this.loading = true;
    await this.getVacancyTotalRecords();
    await this.getVacancyList(
      {
        page: 1,
        itemsPerPage: PAGE_SIZE,
      },
    ).then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
  beforeDestroy() {
    this.clearVacancyData();
  },
  methods: {
    ...mapActions([
      'getVacancyList',
      'getVacancyTotalRecords',
      'clearVacancyData',
    ]),
    async changePage(page) {
      scrollToTop();
      this.loading = true;
      await this.getVacancyList(
        {
          page,
          itemsPerPage: PAGE_SIZE,
        },
      ).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
